import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ErrorList() {
  const navigate = useNavigate();
  // State for date and time
  const [dateTime, setDateTime] = useState({ dateStr: '', timeStr: '' });
  
  // State for header data
  const [headerData, setHeaderData] = useState({
    despatchSlNo: '',
    permanentSlNo: ''
  });

  // Fetch header data from localStorage
  useEffect(() => {
    try {
      const balanceSheetData = localStorage.getItem('balanceSheetFormData');
      if (balanceSheetData) {
        const parsedData = JSON.parse(balanceSheetData);
        setHeaderData({
          despatchSlNo: parsedData.dslNo || '',
          permanentSlNo: parsedData.pslNo || ''
        });
      }
    } catch (error) {
      console.error('Error fetching header data from localStorage:', error);
    }
  }, []);

  // Get current date and time - only once on component mount
  useEffect(() => {
    const now = new Date();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    const dayName = days[now.getDay()];
    const monthName = months[now.getMonth()];
    const date = now.getDate();
    const year = now.getFullYear();
    
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const period = now.getHours() >= 12 ? 'PM' : 'AM';
    
    setDateTime({
      dateStr: `${dayName}, ${monthName} ${date}, ${year}`,
      timeStr: `${hours}:${minutes}:${seconds} ${period}`
    });
  }, []); // Empty dependency array - runs only once on mount

  const { dateStr, timeStr } = dateTime;
  return (
    <>
      <style>
        {`
          .error-list-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .company-info {
            color: #333;
            font-size: 16px;
            font-weight: 500;
            margin: 0;
          }
          .date-time {
            color: #1976d2;
            font-size: 13px;
            font-weight: 500;
            margin: 2px 0;
          }
          .green-icon {
            color: #4caf50;
            font-size: 20px;
            margin-right: 10px;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: bold;
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 10px 6px;
            border: 1px solid #dee2e6;
            white-space: nowrap;
          }
          .table td {
            border: 1px solid #dee2e6;
            padding: 8px 6px;
            font-size: 12px;
            text-align: left;
            vertical-align: middle;
          }
          .table tbody tr:nth-child(even) {
            background-color: #f8f9fa;
          }
          .table tbody tr:nth-child(odd) {
            background-color: #ffffff;
          }
          .sl-no {
            text-align: center;
            font-weight: 600;
            color: #1976d2;
          }
          .error-description {
            text-align: left;
            font-size: 11px;
          }
          .footer-section {
            background-color: #f8f9fa;
            padding: 15px 20px;
            border-top: 1px solid #dee2e6;
            margin-top: 20px;
          }
          .footer-date {
            color: #666;
            font-size: 14px;
            margin: 0;
          }
          .footer-page {
            color: #666;
            font-size: 14px;
            text-align: right;
            margin: 0;
          }
          .table-responsive {
            overflow-x: auto;
            max-width: 100%;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="error-list-header">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <i className="fa fa-exclamation-circle green-icon"></i>
                <h1 className="page-title">Error List</h1>
              </div>
            </div>
            <div className="col-md-4 text-center">
              <p className="company-info" style={{ display: 'flex', justifyContent: 'center', gap: '40px' }}>
                <span>DSL No: {headerData.despatchSlNo}</span>
                <span>PSL No: {headerData.permanentSlNo}</span>
              </p>
            </div>
            <div className="col-md-4 text-end">
              <p className="company-info date-time">{dateStr}</p>
              <p className="company-info date-time">{timeStr}</p>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="card mx-3 mb-3">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th style={{ width: '10%', textAlign: 'left' }}>Sl No.</th>
                    <th style={{ width: '90%', textAlign: 'left' }}>Error Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="sl-no">1</td>
                    <td className="error-description">NIC code as per return is incorrect.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">2</td>
                    <td className="error-description">Description of industry cannot be blank.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">3</td>
                    <td className="error-description">Sector Code cannot be blank.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">4</td>
                    <td className="error-description">Status Code cannot be blank.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">5</td>
                    <td className="error-description">Organization code cannot be blank.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">6</td>
                    <td className="error-description">Ownership code cannot be blank.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">7</td>
                    <td className="error-description">ISO certification is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">8</td>
                    <td className="error-description">Year of initial production is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">9</td>
                    <td className="error-description">Block B, Item 10 is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">10</td>
                    <td className="error-description">Name and designation of contact person is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">11</td>
                    <td className="error-description">Building is neither owned nor rented (Check Block C 2 and F 8).</td>
                  </tr>
                  <tr>
                    <td className="sl-no">12</td>
                    <td className="error-description">Opening cash and bank balance cannot be 0 in Block D.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">13</td>
                    <td className="error-description">Closing cash and bank balance cannot be 0 in Block D.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">14</td>
                    <td className="error-description">Average salaries/wages per manday worked is low.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">15</td>
                    <td className="error-description">PF is 0. Give suitable remark.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">16</td>
                    <td className="error-description">Rate of electricity is too low/high (not between 2 and 25).</td>
                  </tr>
                  <tr>
                    <td className="sl-no">17</td>
                    <td className="error-description">Some item/items in Block K are not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">18</td>
                    <td className="error-description">Some item/items in Block L are not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">19</td>
                    <td className="error-description">Name of Supdt. not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">20</td>
                    <td className="error-description">Name and designation of Scrutinizing officer is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">21</td>
                    <td className="error-description">Date of receipt is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">22</td>
                    <td className="error-description">Date of verification is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">23</td>
                    <td className="error-description">Date of submission is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">24</td>
                    <td className="error-description">Date of scrutiny is not filled in.</td>
                  </tr>
                  <tr>
                    <td className="sl-no">25</td>
                    <td className="error-description">- CHECKS FOR INFORMATION Only - The Net Closing Value of Building is = 0 and BuildingRENT = 0 This is just for checking the possiblity whether Building is neither owned nor rented</td>
                  </tr>
                  <tr>
                    <td className="sl-no">26</td>
                    <td className="error-description">Date of despatch is not filled in.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">

            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/validation')}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/net-profit-tally')}
            >
              <i className="fa fa-angle-left me-1"></i>
              Previous
            </button>
            
          </div>
        </div>
      </div>
    </>
  );
}

export default ErrorList; 